import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f78c9912"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-100"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_3 = { class: "text-value" }
const _hoisted_4 = { class: "text-muted mb-5" }
const _hoisted_5 = {
  key: 3,
  class: "emptyText"
}

import { withDefaults, watch, ref } from 'vue';
import { MoleculeCard } from '@/components/molecules';
import { AtomToogleButton } from '@/components/atoms';
import VueHighcharts from 'vue3-highcharts';
import { IDataChart, IDataChartMore, IOptionsSelect, IToggleButon } from '@/types';
import { color } from 'highcharts';

interface IProps {
  textEmpty?: string;
  title: string;
  legend: boolean;
  showInfoTitle?: boolean;
  data: Array<IDataChart> | IDataChartMore[];
  type: string;
  textX?: string;
  textValueTitle?: string;
  valueTitle?: number;
  textY?: string;
  label?: string;
  hasToggle?: boolean;
  noCard?: boolean;
  buttons?: IToggleButon[];
  hasDropdownList?: boolean;
  optionsDropDown?: IOptionsSelect[];
  colorSeries: string;
  backgroundColor?: string;
  height?: number;
  hasTabs?: boolean;
  loading?: boolean;
  footer?: boolean;
  regexMostrarY?: () => string;
  regexMostrarX?: () => string;
  isCalendarSelect?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsChart',
  props: {
    textEmpty: {},
    title: { default: '' },
    legend: { type: Boolean, default: false },
    showInfoTitle: { type: Boolean, default: false },
    data: {},
    type: {},
    textX: {},
    textValueTitle: {},
    valueTitle: {},
    textY: {},
    label: {},
    hasToggle: { type: Boolean },
    noCard: { type: Boolean, default: false },
    buttons: {},
    hasDropdownList: { type: Boolean },
    optionsDropDown: {},
    colorSeries: { default: '#000' },
    backgroundColor: { default: '#fff' },
    height: {},
    hasTabs: { type: Boolean, default: false },
    loading: { type: Boolean },
    footer: { type: Boolean },
    regexMostrarY: {},
    regexMostrarX: {},
    isCalendarSelect: { type: Boolean, default: false }
  },
  emits: ['handleToggle', 'onChangeDropDownList'],
  setup(__props: any, { emit: __emit }) {

const isEmpty = ref<boolean>(false);
const props = __props;
const emit = __emit;
let chartOptions = ref<any>({});

let series: any[] = [];
let categories: any[] | undefined = [];


changeChartOptions();
function changeChartOptions() {

  var yAxisLabel = props.regexMostrarY ? {
    labels: {
      formatter: props.regexMostrarY
    }
  } : {};


  var xAxisLabel = props.regexMostrarX ? {
    labels: {
      formatter: props.regexMostrarX
    }
  } : {};

  if (props.data[0]) {
    if ('name' in props.data[0]) {
      const data = props.data as IDataChartMore[];

      series = data.map((f) => {
        return {
          showInLegend: props.legend,
          name: f.name,
          color: f.color,
          data: f.data.map((f) => f.value),
        };
      });

      isEmpty.value = data.filter(f => f.data.length == 0).length == data.length;
      categories = data.map((f) => f.data.map((f) => f.title))[0];
    } else {
      series = [
        {
          showInLegend: props.legend,
          name: props.textX,
          data: (props.data as IDataChart[]).map((f) => f.value),
          color: props.colorSeries,
        },
      ];
      isEmpty.value = (props.data as IDataChart[]).length == 0;
      categories = (props.data as IDataChart[]).map((f) => f.title);
    }

  }
  else {
    series = [
      {
        showInLegend: props.legend,
        name: props.textX,
        data: (props.data as IDataChart[]).map((f) => f.value),
        color: props.colorSeries,
      },
    ];
    isEmpty.value = (props.data as IDataChart[]).length == 0;
    categories = (props.data as IDataChart[]).map((f) => f.title);
  }
  chartOptions.value = {
    chart: {
      backgroundColor: props.backgroundColor,
      type: props.type,
      height: props.height,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: categories,
      ...xAxisLabel
    },
    yAxis: {
      title: {
        text: props.textY,
      },
      ...yAxisLabel
    },
    plotOptions: {
      series: {
        borderRadius: 18,
      },
    },
    series: series,
    tooltip: {
      formatter: !props.regexMostrarY ? undefined : props.regexMostrarY
    },
  };

}

function handleToogleChange($event) {
  emit('handleToggle', $event);
}

function handleChangeDropdownList(event) {
  emit('onChangeDropDownList', event);
}

watch(
  () => props.data,
  () => {
    changeChartOptions();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_ctx.noCard)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(VueHighcharts), {
          type: "chart",
          options: _unref(chartOptions),
          redrawOnUpdate: true,
          oneToOneUpdate: false,
          animateOnUpdate: true
        }, null, 8, ["options"])
      ]))
    : (_openBlock(), _createBlock(_unref(MoleculeCard), {
        key: 1,
        footer: props.footer,
        onOnChangeDropDownList: handleChangeDropdownList,
        "has-dropdown-list": props.hasDropdownList,
        "options-drop-down": props.optionsDropDown,
        label: props.label,
        "is-calendar-select": props.isCalendarSelect,
        textTooltip: 'textTooltip',
        title: props.title,
        hasTabs: props.hasTabs,
        loading: props.loading
      }, {
        tabs: _withCtx(() => [
          _renderSlot(_ctx.$slots, "tabs")
        ]),
        default: _withCtx(() => [
          (props.hasToggle && !isEmpty.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(AtomToogleButton), {
                  buttons: props.buttons ?? [],
                  onHandleToggle: handleToogleChange
                }, null, 8, ["buttons"])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "topfreeArea"),
          (_ctx.showInfoTitle)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.valueTitle), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.textValueTitle), 1)
              ], 64))
            : _createCommentVNode("", true),
          (!isEmpty.value)
            ? (_openBlock(), _createBlock(_unref(VueHighcharts), {
                key: 2,
                type: "chart",
                options: _unref(chartOptions),
                redrawOnUpdate: true,
                oneToOneUpdate: false,
                animateOnUpdate: true
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (isEmpty.value && props.textEmpty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.textEmpty), 1))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["footer", "has-dropdown-list", "options-drop-down", "label", "is-calendar-select", "title", "hasTabs", "loading"]))
}
}

})